export default __webpack_public_path__ + "static/media/set9.b3da22bd.jpeg";